export const getJwt = () => localStorage.getItem('jwt');
export const setJwt = (jwt) => localStorage.setItem('jwt', jwt);
export const logout = (refer) => {
    const { pathname } = window.location;
    setJwt('');

    if (window.location.pathname !== '/login') {
        const ref = pathname.length > 1 && refer ? `?ref=${pathname}` : '';
        window.location.assign(`/login${ref}`);
    }
};



// WEBPACK FOOTER //
// ./src/utils/jwt.js